import { render, staticRenderFns } from "./MobileHomePortofolio.vue?vue&type=template&id=39d7b234&lang=pug&"
import script from "./MobileHomePortofolio.vue?vue&type=script&lang=js&"
export * from "./MobileHomePortofolio.vue?vue&type=script&lang=js&"
import style0 from "./MobileHomePortofolio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports